<template>
    <div class="htEvent">
        <template v-if="tokens.id_token == ''">
            <div class="htEvent-title" v-html="$t('htEvent_text1')"></div>
            <div class="htEvent-cont">
                <div v-if="routeName == 'htFree'" style="margin-bottom: 7px;" v-html="$t('htEvent_text2')"></div>
                <div v-html="$t('htEvent_text3')"></div>
            </div>
            <div class="htEvent-cont">
                <img style="width: 100%;border-radius: 30px;" :src="ht333_introduce_src" />
            </div>
            <div style="display: flex;flex-direction: column;align-items: center;">
                <h3>{{isLoginFlag ? $t('htEvent_text4') : $t('htEvent_text5')}}</h3>
                <!-- 教育雲登入 -->
                <n-button v-if="lang == 'tw'"  @click="loginByPrvider('educloudtw')" ghost color="#9e9e9e" text-color="#333" style="min-width: 350px;margin-bottom: 7px;">
                    <template #icon>
                        <img style="width: 15px;height:15px;" src="@/assets/img/thirdIcon/educloudtw.png">
                    </template>
                    {{isLoginFlag ? $t('htEvent_text6', {provider: $t('public_eduCloud')}) : $t('htEvent_text7', {provider: $t('public_eduCloud')})}}
                </n-button>
                <!-- google -->
                <n-button v-if="lang != 'cn'" @click="loginByPrvider('google')" ghost color="#9e9e9e" text-color="#333" style="min-width: 350px;margin-bottom: 7px;">
                    <template #icon>
                        <img style="width: 15px;height:15px;" src="@/assets/img/thirdIcon/google.png">
                    </template>
                    {{isLoginFlag ? $t('htEvent_text6', {provider: $t('public_google')}) : $t('htEvent_text7', {provider: $t('public_google')})}}
                </n-button>
                <!-- facebook -->
                <!-- <n-button v-if="lang != 'cn'" @click="loginByPrvider('facebook')" ghost color="#9e9e9e" text-color="#333" style="min-width: 350px;margin-bottom: 7px;">
                    <template #icon>
                        <img style="width: 15px;height:15px;" src="@/assets/img/thirdIcon/fb.png">
                    </template>
                    {{isLoginFlag ? $t('htEvent_text6', {provider: $t('public_facebook')}) : $t('htEvent_text7', {provider: $t('public_facebook')})}}
                </n-button> -->
                <!-- 微信登入 -->
                <n-button v-if="lang == 'cn'" @click="loginByPrvider('wechat')" ghost color="#9e9e9e" text-color="#333" style="min-width: 350px;margin-bottom: 7px;">
                    <template #icon>
                        <img style="width: 15px;height:15px;" src="@/assets/img/thirdIcon/wc.png">
                    </template>
                    {{isLoginFlag ? $t('htEvent_text6', {provider: $t('public_wechat')}) : $t('htEvent_text7', {provider: $t('public_wechat')})}}
                </n-button>
                <div class="otherloginTitle" style="margin-bottom: 14px;">
                    <span>{{ $t('htEvent_text8') }}</span>
                </div>
                <template v-if="isLoginFlag">
                    <n-form ref="accRef" :model="accForm" :rules="accRules" size="medium" :style="{minWidth: '350px'}" :show-label="false" @keydown.enter="validAcc">
                        <n-form-item path="id">
                            <n-input type="text" v-model:value="accForm.id" round  :placeholder="$t('htEvent_text9')" />
                        </n-form-item>
                        <n-form-item path="pass">
                            <n-input type="password" show-password-on="click" v-model:value="accForm.pass" round  :placeholder="$t('htEvent_text10')" />
                        </n-form-item>
                    </n-form>                    
                    <n-button type="info" @click="validAcc" round style="width: 350px;margin-bottom: 7px;">{{$t('htEvent_text11')}}</n-button>
                </template>
                <n-button v-else type="info" round style="width: 350px;margin-bottom: 7px;" @click="registAcc()">{{ $t('htEvent_text13') }}</n-button>
                <div v-if="isLoginFlag">
                    {{ $t('htEvent_text14') }} <n-button style="color: blue;margin-top: 14px;" text tag="a" type="tertiary" @click="isLoginFlag = !isLoginFlag">{{ $t('htEvent_text15') }}</n-button>
                </div>
                <div v-else>
                    {{ $t('htEvent_text16') }} <n-button style="color: blue;margin-top: 14px;" text tag="a" type="tertiary" @click="isLoginFlag = !isLoginFlag">{{ $t('htEvent_text17') }}</n-button>
                </div>
            </div>
        </template>
        <template v-else>
            <template v-if="!isFinsh">
                <div class="htEvent-title" v-html="$t('htEvent_text1')"></div>
                <div class="ht333First-cont" v-html="$t('ht333first_text1')"></div>
                <div class="ht333First-cont" style="margin-bottom: 25px;">
                    ● <span style="color: #FF9800;" v-html="$t('htEvent_text18')"></span>
                </div>

                <base-ex ref="baseEXE" class="ht333First-form" :key="refreshKey"></base-ex>
                <div style="display: flex;justify-content: space-evenly;">
                    <n-button type="info" @click="validForm()" :disabled="!isFormFinsh">{{ $t('htEvent_text19') }}</n-button>
                    <n-button type="default" @click="logOut()">{{ $t('htEvent_text20') }}</n-button>
                </div>
            </template>
            <template v-else>
                <div class="htEvent-title" v-html="$t('htEvent_text21')"></div>
                <div class="event3 scrollstyle" id="event3">
                    <div class="event3-step">
                        <div class="stepFinshFrame">
                            <div class="cont" :class="{'en': lang =='en'}">
                                {{ $t('hiteach333_finsh') }}
                            </div>
                        </div>
                        <div class="event3-step-title">
                            {{ $t('hiteach333_text3') }}
                        </div>
                        <div class="event3-step-subTitle">
                            － {{ $t('ht333first_text3') }}
                        </div>
                    </div>
                    <div class="event3-arrow">
                        <n-icon size="25" color="#333" :component="ChevronDown"/>
                    </div>
                    <div class="event3-step">
                        <div v-if="isStage2Finish" class="stepFinshFrame">
                            <div class="cont" :class="{'en': lang =='en'}">
                                {{ $t('hiteach333_finsh') }}
                            </div>
                        </div>
                        <div style="display: flex;align-items: center;justify-content: space-between;">
                            <div>
                                <div class="event3-step-title">
                                    {{ $t('hiteach333_text6') }}
                                    <n-icon style="margin-left: 5px;" size="23" color="#2196F3" :component="InformationCircleOutline"/>
                                </div>
                                <div class="event3-step-subTitle">
                                    － {{ $t('ht333first_text4') }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="event3-arrow">
                        <n-icon size="25" color="#333" :component="ChevronDown"/>
                    </div>
                    <div class="event3-step">
                        <div v-if="isStage3Finish" class="stepFinshFrame">
                            <div class="cont" :class="{'en': lang =='en'}">
                                {{ $t('hiteach333_finsh') }}
                            </div>
                        </div>
                        <div class="event3-step-title">
                            {{ $t('hiteach333_text9')}}
                        </div>
                        <div class="event3-step-subTitle">
                            － {{ $t('ht333first_text4') }}
                        </div>
                    </div>
                    <div style="margin-top: 45px"></div>
                    <div v-if="routeName == 'htFree'" style="font-size: 20px;margin: 0px 0 0px 0;font-family: Verdana;" v-html="$t('htEvent_text22')"></div>
                    <div style="font-size: 20px;margin: 0px 0 12px 0;font-family: Verdana;" v-html="$t('htEvent_text23')"></div>
                    <div class="qrcodes">
                        <div class="qrcode" @click="downloadLink('applestore')">
                            <img :src="qrcode_i_appstore">
                            <div>{{ $t('ht333first_text5') }}</div>
                        </div>
                        <div class="qrcode" @click="downloadLink('googleplay')">
                            <img :src="qrcode_a_googlplay">
                            <div>{{ $t('ht333first_text6') }}</div>
                        </div>
                        <div class="qrcode" @click="downloadLink('apk')">
                            <img :src="qrcode_a_d_apk">
                            <div>{{ $t('ht333first_text7') }}</div>
                        </div>
                    </div>
                    <div v-if="routeName == 'htFree'" class="event3-video">
                        <iframe width="100%" height="400px" style="border-radius: 30px;" src="https://www.youtube.com/embed/uKwpkqX6MCk?si=FamcNAA7fjVkv88x" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        <div style="text-align: center;">{{ $t('htEvent_text24') }} <a href="https://youtube.com/playlist?list=PLLvW_gXdUr-DFKNsoEZZGJCK3Ci23dQsp&si=mxmu6lSv5kKnZRat">{{ $t('htEvent_text25') }}</a></div>
                    </div>
                    <div class="event3-remark">
                        <ul>
                            <li>{{ $t('hiteach333_text12')}}</li>
                            <li>{{ $t('hiteach333_text13')}}</li>
                            <li v-html="$t('hiteach333_text14')"></li>
                            <li v-html="$t('ht333first_text11')"></li>                            
                        </ul>
                    </div>
                </div>
                <div v-if="routeName == 'htEvent'" style="text-align: center;">
                    <n-button round type="info" @click="loginHT()">{{ $t('htEvent_text26') }}</n-button>
                </div>
                <div v-if="routeName == 'htFree'" style="text-align: center;">
                    <n-button round type="info" @click="logOut()">{{ $t('htEvent_text12') }}</n-button>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
import { defineComponent, onMounted, inject, computed, ref, reactive, h } from 'vue'
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { jsFn } from "@/utils/jsFn";
import { useStore } from "vuex";
import naiveFnc from "@/utils/naiveFnc";
import baseex from '@/components/baseEX.vue'
import { ChevronDown, DownloadOutline } from '@vicons/ionicons5'
import { useDialog, NButton} from 'naive-ui'

export default defineComponent({
    components: {
        'base-ex': baseex
    },
    setup() {
        const dialog = useDialog()
        const { crtDialog } = naiveFnc();
        const changeSpinState = inject('changeSpinState')
        const route = useRoute();
        const router = useRouter();
        const i18n = useI18n();
        const { t } = i18n;
        const store = useStore();
        var lang = route.params.lang;
        const coupons = computed(() => store.getters["coreApi/coupons"]);
        const HT333Coupon = computed(() => store.getters['coreApi/getEvCoupon']('HITEACH50'))
        const Coupon_AITEXT = computed(() => store.getters['coreApi/getEvCoupon']('AITEXT-2026'))
        const Coupon_SOKLITE = computed(() => store.getters['coreApi/getEvCoupon']('SOKLITE-2026'))
        const eventCouponIds = store.state.coreApi.eventCouponIds
        const tokens = computed(() => store.getters["coreApi/tokens"]);
        const baseEXCheckKey = computed(() => store.getters["coreApi/baseEXCheckKey"]);
        const events = computed(() => store.getters["coreApi/events"]);
        const baseEx = computed(() => store.getters['coreApi/baseEx']);
        const refreshKey = ref(0)
        const baseEXE = ref()
        const isFinsh = ref(false)
        const isEventSuccess = ref(false)
        const isStage2Finish = ref(false)
        const isStage3Finish = ref(false)
        const isLoginFlag = ref(false)
        const accRef = ref(null)
        const accForm = reactive({
            id: "",
            pass: "",
        })
        const routeName = route.name
        const accRules = {
            id: [
                {
                    required: true,
                    validator(rule, value) {
                        if (!value) {
                            return new Error(t('error_14'));
                        } else if (value.search(/^\+/) === 0) {
                            return new Error(t('error_15'));
                        }
                        return true;
                    },
                    trigger: ["blur"]
                }
            ],
            pass: [
                {
                    required: true,
                    message: t('error_14'),
                    trigger: ["blur"]
                }
            ]
        }

        // 設定頁面的語系(目前支援的)
        switch(lang) {
            case'tw':
            case'cn':
            case'jp':
            case'en':
            break;
            default:
            lang = 'en'
        }

        i18n.locale.value = lang;
        localStorage.setItem("lang", lang);

        var qrcode_a_d_apk = require("@/assets/img/qrcode_android_download_apk.png");
        var qrcode_a_googlplay = require("@/assets/img/qrcode_android_googleplay.png");
        var qrcode_i_appstore = require("@/assets/img/qrcode_ios_appstore.png");
        var ht333_introduce_tw = require("@/assets/img/htEvent_introduce_banner_tw.jpg");
        var ht333_introduce_cn = require("@/assets/img/htEvent_introduce_banner_cn.jpg");
        var ht333_introduce_en = require("@/assets/img/htEvent_introduce_banner_en.jpg");
        var ht333_introduce_jp = require("@/assets/img/htEvent_introduce_banner_jp.jpg");

        var htLogo_src = require("@/assets/img/HiTeach5_logo.png");
        var ht333_introduce_src = ht333_introduce_en

        switch(lang) {
            case'tw':
                ht333_introduce_src = ht333_introduce_tw
            break
            case'cn':
                ht333_introduce_src = ht333_introduce_cn
            break
            case'jp':
                ht333_introduce_src = ht333_introduce_jp
            break
        }

        // 設定都完成按鈕亮燈
        const isFormFinsh = computed(()=>{
            let flag = true
            baseEXCheckKey.value.forEach(c=>{
                switch(c){
                    case 'schoolCode':
                        // 暫不檢查
                        // if(baseEXE.value?.baseExValue['country'] == 'TW' && (baseEXE.value?.baseExValue[c] == '' || baseEXE.value?.baseExValue[c] == null)){
                        //     flag = false
                        // }
                    break
                    default:
                        if(baseEXE.value?.baseExValue[c] == '' || baseEXE.value?.baseExValue[c] == null) {
                            flag = false
                        }
                }
            })
            return flag
        })

        async function loginHT() {
            //取得個人在base-ex的設定檔
            await store.dispatch("coreApi/getCode").then(res=>{
                location.href = `/login/HT?code=${res.code}`;
            }).catch(()=>{
                crtDialog(t('notice'), t('htEvent_text27'))
            });
        }

        function registAcc(){
            let station = 'net'
            let callbackUrl = location.href
            if(lang == 'cn') {
                station = 'cn'
            }

            location.href = `https://account.teammodel.${station}/regist?callback=${callbackUrl}`
        }

        const logOut = () => {
            localStorage.clear()

            if(routeName == 'htEvent') {
                location.href = `/logout/HT`;
            } else {
                location.reload()
            }
        }

        function login(){
            let station = 'net'
            let callbackUrl = location.href
            if(lang == 'cn') {
                station = 'cn'
            }

            location.href = `https://account.teammodel.${station}/?callback=${callbackUrl}`
        }

        function loginByPrvider(provider) {
            let station = 'net'
            let callbackUrl = location.href
            if(lang == 'cn') {
                station = 'cn'
            }
            
            location.href = `https://account.teammodel.${station}/?autolink=${provider}&callback=${callbackUrl}`
        }

        // 欄位檢查
        const validForm = ()=>{
            baseEXE.value.baseExFormRef.validate(
                async(errors) => {
                    if (!errors) {
                        changeSpinState() // 開啟全屏spin
                        let data = {}
                        if(baseEx.value){
                            let bKeys = Object.keys(baseEx.value)

                            bKeys.forEach(k=>{
                                if(baseEXE.value.baseExValue[k]) {
                                    data[k] = baseEXE.value.baseExValue[k]
                                } else {
                                    data[k] = baseEx.value[k]
                                }
                            })
                        } else {
                            data = baseEXE.value.baseExValue
                        }


                        // 修改名稱
                        await store.dispatch("coreApi/tmdProfile", {grantType: 'name', name: data['name']})

                        // 寫入baseEX
                        await store.dispatch('coreApi/setUserContact', data)

                        // 申請加入學校
                        if(data['schoolCode']) {
                            await store.dispatch("ies5Api/applySchool", data['schoolCode'])
                            await store.dispatch("sokplatformApi/applyChannel", data['schoolCode'])
                        }
                        
                        let content = ["","","","","",""];

                        // 兌換333
                        await exchangeCoupon(HT333Coupon.value).then(res=>{
                            if(res) {
                                res.forEach( r=>{
                                    let func = r.func
                                    switch(func){
                                        case "cowork":
                                            content.splice(2,1,h('li', t('htEvent_text36')))
                                        break
                                        case "smartrating":
                                            content.splice(1,1,h('li', t('htEvent_text35')))
                                        break
                                        case "aigpt":
                                            content.splice(3,1,h('li', t('htEvent_text34')))
                                        break
                                        case "webirs":
                                            content.splice(0,1,h('li', t('htEvent_text28')))
                                        break
                                    }
                                })
                            }
                        })
                        // 兌換AI TEXT
                        await exchangeCoupon(Coupon_AITEXT.value).then(res=>{
                            if(res) {
                                content.splice(4,1,h('li', t('htEvent_text32')))
                            }
                        })
                        // 兌換蘇格拉底小數據
                        await exchangeCoupon(Coupon_SOKLITE.value).then(res=>{
                            if(res) {
                                content.splice(5,1,h('li', t('htEvent_text33')))
                            }
                        })

                        isFinsh.value = true

                        // 檢查是否有空字串並拿掉
                        content = content.filter(item => item);

                        dialog.create({
                            class: 'eventDialog',
                            style: {
                            width: '350px',
                            'text-align': 'center',
                            'border-radius': '10px'
                            },
                            maskClosable: false,
                            closable: false,
                            showIcon: false,
                            title: () => h('h3',{'style': 'text-align: center;width: 100%;margin: 0;'}, t('htEvent_text31')),
                            content: () => h('span',{'style': 'white-space: pre-line;'}, h('ol',{'style': 'text-align: left;'} , content)),
                            action: () => h(NButton, { text: true, color: '#00c4fb', onClick:()=>{dialog.destroyAll()} }, () => t('ok'))
                        })
                        changeSpinState() // 關閉全屏spin
                    }
                }
            )
        }

        async function exchangeCoupon(coupon){
            let res = await getCoupon(coupon.code)
            if(res.state > 0){
                crtDialog(t('notice'), res.msg)
                return false
            } else {
                let eRes = await exchangeVoucher(res.data.voucher)
                if(eRes.state > 0){
                    crtDialog(t('notice'), eRes.msg)
                    return false
                } else {
                    let result = res.data
                    let eventName = ''
                    if(result.eventName != null && typeof result.eventName != 'undefined') {
                        let eventTemp = result.eventName.split('-')
                        eventName = eventTemp[0].toLocaleLowerCase()
                    }

                    // 活動券設定
                    if(eventName != '' && eventCouponIds.indexOf(eventName)  != -1) {
                        await store.dispatch("coreApi/setUserEvents", {name: eventName, step: 1, done: new Date().getTime()})
                    }

                    // 優惠券設定
                    let temp = coupons.value.filter( y => y.code == coupon.code)

                    if(temp.length > 0){
                        coupon.isExchange = true
                        coupon.endTime = new Date().getTime()

                        store.dispatch('coreApi/updUserCoupons', coupon)
                    } else {
                        let ticket = {
                            type: coupon.type,
                            code: coupon.code,   // 兌換卷號
                            info: [], 
                            expire: result.expire, // 到期日
                            isExchange: true,// 是否被兌換
                            isExpired: false, // 是否已過期
                            endTime: new Date().getTime(),      // 結束時間(包含兌換與過期時間，預計保留半年)
                            eventName: eventName
                        }

                        if(result.info) {
                            ticket.info = JSON.parse(result.info)
                        }

                        if(ticket.info.length == 0){
                            if(coupon.title) ticket.title = coupon.title
                            if(coupon.cont) ticket.cont = coupon.cont
                        }

                        store.dispatch('coreApi/setUserCoupons', ticket)
                    }
                
                    await store.dispatch("coreApi/setUsersetting") // 儲存現在的usersetting
                    await store.dispatch("coreApi/getUsersetting", 'mynews') //取得個人在mynews的設定檔

                    return eRes.data
                }
            }            
        }

        // 取得voucher
        async function getCoupon(code){
            let errStr = ''
            let data = {}
            await store.dispatch('coreApi/getCoupon', code).then( res => {
                if(res.error) {
                    let error = res.error.toString()
                    switch(error) {
                        case '9':
                            errStr = t('error_9')
                        break
                        case '14':
                            errStr = t('error_10')
                        break
                        case '15':
                            errStr = t('error_11')
                        break
                        case '20':
                            errStr = t('error_12')
                        break
                    }
                } else {
                    data = res
                }
            }).catch( () =>{
                errStr = t('error_3')
            })

            if(errStr != ''){
                return {state: 1, msg: errStr}
            } else {
                return {state: 0, data: data}
            }
        }

        // 兌換voucher
        async function exchangeVoucher(voucher){
            let errStr = ''
            let data = null
            await store.dispatch('coreApi/exchangeVoucher', voucher).then( res => {
                if(res.error) {
                    let error = res.error.toString()
                    switch(error) {
                        // case '8':
                        //   errStr = '票卷已過期'
                        // break
                        // case '9':
                        //   errStr = '你已使用過該票券'
                        // break
                        // case '12':
                        //     errStr = '活動尚未開始'
                        // break
                        // case '16':
                        //     errStr = '降規格(權益折損)'
                        // break
                        default:
                        errStr = t('error_10')
                    }
                } else {
                    data = res
                }
            }).catch( () =>{
                errStr = t('error_3')
            })

            if(errStr != ''){
                return {state: 1, msg: errStr, data: data}
            } else {
                return {state: 0, msg: '', data: data}
            }
        }

        function checkJoinEvent() {
            // 檢查是否參加過活動(50 333擇一)
            let temp = events.value.filter( y => {
                return (y.name.toLocaleLowerCase() == 'hiteach333' || y.name.toLocaleLowerCase() == 'hiteach50')
            })

            // 大於0代表已參加過活動
            if(temp.length > 0){
                isEventSuccess.value = true
                isFinsh.value = true

                if(events.value){                    
                    events.value.forEach(x => {
                        if(x.name == 'hiteach333' || x.name == 'hiteach50') {
                            x.steps.forEach( y => {
                                switch (y.step){
                                    case 2:
                                        if(y.done != -1) isStage2Finish.value = true
                                    break
                                    case 3:
                                        if(y.done != -1) isStage3Finish.value = true
                                    break
                                }
                            })
                        }
                    })
                }
            } else {
                console.log('沒參加過活動')
            }
        }

        const validAcc = () =>{
            accRef.value?.validate(
                async(errors) => {
                    if (!errors) {
                        changeSpinState() // 全屏spin

                        await store.dispatch("coreApi/resetState") // 先重置

                        var res = await store.dispatch("coreApi/accLogin", accForm)
                        if (res) {
                            // 登入成功
                            //取得個人在base-ex的設定檔
                            await store.dispatch("coreApi/getUsersetting", 'base-ex')

                            //取得個人在mynews的設定檔
                            await store.dispatch("coreApi/getUsersetting", 'mynews')

                            refreshKey.value += 1
                        } else {
                            crtDialog(t('notice'), '登入失敗')
                        }

                        checkJoinEvent() // 檢查是否參加過活動
                        changeSpinState() // 全屏spin
                    }
                }
            )
        }

        const downloadLink = (type) => {
            console.log(type)
            switch(type) {
                case 'applestore':
                    location.href = "https://apps.apple.com/ca/app/hita-5/id1562290912";
                    break;
                case 'googleplay':
                    location.href = "https://play.google.com/store/apps/details?id=com.habook.hita5";
                    break;
                case 'apk': {
                    let station = 'net'
                    if(lang == 'cn') {
                        station = 'cn'
                    }

                    location.href = `https://coreblob.teammodel.${station}/public/HiTA/APK/HiTA5.apk`;
                    break;
                }
            }
        }

        // USER 快速登入
        onMounted(async() => {
            if (!jsFn.IsEmpty(route.query.ticket) || !jsFn.IsEmpty(route.query.code)) {
                changeSpinState() // 全屏spin

                let code = route.query.ticket ? route.query.ticket : route.query.code ? route.query.code : ''

                // 先重置
                await store.dispatch("coreApi/resetState")

                var res = await store.dispatch("coreApi/codeLogin", code)
                if (res) {
                    // 登入成功
                    //取得個人在base-ex的設定檔
                    await store.dispatch("coreApi/getUsersetting", 'base-ex')

                    //取得個人在mynews的設定檔
                    await store.dispatch("coreApi/getUsersetting", 'mynews')

                    refreshKey.value += 1
                } else {
                    crtDialog(t('notice'), t('htEvent_text29'))
                }

                router.push({ path: route.path })
                changeSpinState() // 全屏spin
            }

            checkJoinEvent()
        });

        return {
           ht333_introduce_src,
           registAcc,
           loginByPrvider,
           tokens,
           refreshKey,
           baseEXE,
           lang,
           isFormFinsh,
           ChevronDown,
           DownloadOutline,
           isFinsh,
           qrcode_a_d_apk,
           qrcode_a_googlplay,
           qrcode_i_appstore,
           loginHT,
           logOut,
           validForm,
           login,
           isLoginFlag,
           accForm,
           accRef,
           accRules,
           validAcc,
           routeName,
           htLogo_src,
           downloadLink,
           isStage2Finish,
           isStage3Finish,
        }
    }
})
</script>

<style  lang="less" scoped>
.htEvent{
    padding: 20px 20px 10px 20px;
    white-space: pre-line;
    &-title{
        color: #2196f3;
        font-size: 25px;
        font-weight: bold;
        margin-bottom: 30px;
        text-align: center;
        font-family: Comic Sans MS;
    }
    &-cont{
        padding: 0 50px;
        font-size: 16px;
        margin-bottom: 25px;
        font-family: Verdana;
    }
    &-form{
        padding: 0 50px;
    }
    
    .otherloginTitle{
        padding-top: 15px;
        text-align: center;
        width: 300px;
        margin-left: auto;
        margin-right: auto;
    }
    .otherloginTitle span {
        display: block;
        font-size: 15px;
        color: #aaa;
        position: relative;
    }
    .otherloginTitle span:before,
    .otherloginTitle span:after {
        content: "";
        position: absolute;
        top: 50%;
        background: #aaa;
        width: 30%;
        height: 1px;
    }
    .otherloginTitle span:before {
        left: 1%;
    }
    .otherloginTitle span:after {
        right: 1%;
    }
    .linkIcon {
        text-align: center;
        display: flex;
        justify-content: center;
        padding: 0;
    }

    .linkIcon li img {
        width: 32px;
        border-radius: 30px;
        display: inline-block;
        vertical-align: bottom;
        background-color: #FAFAFA;
        margin-bottom: 5px;
    }

    .linkIcon li {
        display: inline-block;
        cursor: pointer;
        color: #ffffff;
        /*padding: 8px 15px;*/
        margin: 5px 10px;
        border-radius: 8px;
        /* border: 1px solid #dddee1; */
        width: 55px;
    }

    .linkIcon li:hover {
        opacity: 0.7;
    }

    .linkIcon li.fb, .linkIcon li.fb img {
        background-color: #3a5897;
    }

    .linkIcon li.google, .linkIcon li.google img {
        background-color: #dd4b39;
    }

    .linkIcon li.qq, .linkIcon li.qq img {
        background-color: #51b7ec;
    }

    .linkIcon li.weibo, .linkIcon li.weibo img {
        background-color: #f4511e;
    }

    .linkIcon li.wechat, .linkIcon li.wechat img {
        background-color: #49b848;
    }

    .linkIcon li:active {
        opacity: 0.5;
    }

    .event3 {
        white-space: pre-line;
        position: relative;
        padding: 0 50px;
        font-family: Verdana;
        &-step{
            border: 2px solid #333;
            border-radius: 6px;
            padding: 9px 12px;
            margin-bottom: 7px;
            position: relative;
            &-title{
                font-size: 17px;
                display: flex;
                align-items: center;
                font-weight: bold;
            }
            &-subTitle{
                font-size: 20px;
                display: flex;
                align-items: center;
                color: #2196f3;
            }
            &-subCont{
                font-size: 14px;
                color: #757575;
                border-top: 1px dashed #333;
                margin-top: 15px;
                padding-top: 6px;
            }
            .stepFinshFrame{
                border: 4px solid rgb(230, 74, 25);
                padding: 7px;
                border-radius: 50%;
                color: rgb(230, 74, 25);
                position: absolute;
                right: 0px;
                // top: calc(50% - 42px);
                top: -3px;
                width: 60px;
                height: 60px;
                display: flex;
                justify-content: center;
                align-items: center;
                .cont{
                    display: flex;
                    font-size: 20px;
                    line-height: 1;
                    width: 50px;
                    height: 50px;
                    align-items: center;
                    justify-content: center;
                    transform: rotate(-20deg);
                    border: 1px solid rgb(230, 74, 25);
                    padding: 7px;
                    border-radius: 50%;
                    color: rgb(230, 74, 25);
                    position: absolute;
                    text-align: center;
                    &.en{
                        font-size: 17px;
                    }
                }
            }
        }
        &-arrow{
            display: flex;
            justify-content: center;
            margin-top: 5px;
        }
        &-video{
        }
        &-remark{
            margin-top: 20px;
            ul{
                font-size: 14px;
                padding-left: 20px;
            }
        }
        .qrcodes{
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 17px;
            .qrcode{
                text-align: center;
                img{
                    width: 170px;
                }
                // margin-bottom: 30px;
            }
        }
    }
}
</style>
